import { createApp } from 'vue'
import App from './App.vue'
/* eslint-disable */
import { GoogleMap, AdvancedMarker ,InfoWindow,Polygon   } from 'vue3-google-map'
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";
import "bootstrap/dist/css/bootstrap.min.css"


const app = createApp(App);
app.component('GoogleMap', GoogleMap);
app.component('Marker', AdvancedMarker);
app.component('InfoWindow', InfoWindow);
app.component('Polygon', Polygon);
app.use(VueAwesomePaginate);
app.mount('#app')

import "bootstrap/dist/js/bootstrap.js"